import { ApiService } from '../apiService';

class Branding extends ApiService {
  getBranding() {
    return this.get('company/branding/');
  }
}

export default new Branding();
